(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-to-top"]) return;
  try {
    
  (() => {
    const button = document.querySelector("[data-lw-back-to-top]");

    if (!button) {
      return;
    }

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let lastScrollY = Math.max(window.scrollY, 0);
    let ticking = false;

    const updateVisibility = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const isPastFirstScreen = currentScrollY > window.innerHeight * 0.7;
      const isScrollingUp = currentScrollY < lastScrollY;

      button.classList.toggle("is-visible", isPastFirstScreen && isScrollingUp);
      lastScrollY = currentScrollY;
      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateVisibility);
          ticking = true;
        }
      },
      { passive: true },
    );

    button.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: reduceMotion.matches ? "auto" : "smooth",
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
